<template>
  <button
    type="button"
    class="configurator-btn-dropdown-trigger"
    :title="title"
    :class="{
      'configurator-btn-dropdown-trigger--block': block,
      'configurator-btn-dropdown-trigger--expanded': expanded,
    }"
    @click="onClick"
  >
    <span class="configurator-btn-dropdown-trigger__container">
      <slot>
        {{ label }}
      </slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'ConfiguratorBtnDropdownTrigger',
  model: {
    prop: 'expanded',
    event: 'change',
  },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    expanded: Boolean,
    block: Boolean,
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
      this.$emit('change', !this.expanded);
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-btn-dropdown-trigger {
  cursor: pointer;
  font: inherit;
  background: none;
  border: 0;
  margin: 0;
  color: $color-arapawa;
  display: inline-flex;
  align-items: center;
  transition: color $default-transition-duration;
  text-decoration: underline;
  text-transform: uppercase;
  font-weight: 600;

  // FIXME Focus state should be different than hover state
  &:hover,
  &:focus {
    color: $color-red-thunderbird;
  }

  &--block {
    display: flex;
  }

  &__container {
    text-decoration: underline;
  }
}
</style>
